
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"36","viewBox":"0 0 34 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"gst-svg-icon",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.717 0C7.484 0 0 7.484 0 16.717c0 8.316 6.073 15.214 14.026 16.501l2.678 2.634a.51.51 0 00.713 0l2.703-2.658C28 31.847 34 24.982 34 16.717 34 7.484 26.516 0 17.283 0h-.566z","fill":"#50657c"}}),_c('g',{attrs:{"clip-path":"url(#gst-tenants-aadvantagehotels-app-assets-icons-hotel_round_svg-gst-svg-hotel-round)","fill":"#fff"}},[_c('path',{attrs:{"d":"M21.737 16.067h-9.474c-1.358 0-2.463 1.12-2.463 2.497v3.825c0 .208.168.379.374.379s.374-.17.374-.38v-1.465h12.904v1.466c0 .208.168.379.374.379s.374-.17.374-.38v-3.824c0-1.376-1.105-2.497-2.463-2.497zm-11.189 2.497c0-.96.77-1.738 1.715-1.738h9.472c.947 0 1.715.78 1.715 1.738v1.601H10.548v-1.601z"}}),_c('path',{attrs:{"d":"M11.784 16.443c.21 0 .383-.199.383-.443v-2.315c0-1.12.791-2.031 1.76-2.031h6.146c.97 0 1.76.912 1.76 2.031V16c0 .244.172.443.383.443.211 0 .384-.199.384-.443v-2.315c.002-1.608-1.132-2.917-2.527-2.917h-6.144c-1.395 0-2.529 1.309-2.529 2.917V16c0 .246.173.443.384.443z"}}),_c('path',{attrs:{"d":"M19.341 16.335c.206 0 .374-.17.374-.379v-1.618a1.13 1.13 0 00-1.122-1.138h-3.186c-.62 0-1.122.51-1.122 1.138v1.618c0 .209.168.38.374.38a.379.379 0 00.374-.38v-1.618c0-.209.168-.38.374-.38h3.184c.206 0 .374.171.374.38v1.618a.38.38 0 00.376.38z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"gst-tenants-aadvantagehotels-app-assets-icons-hotel_round_svg-gst-svg-hotel-round"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(9 8.768)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    